import {
  TableBody,
  TableCell,
  TableHead,
  TableProps,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { Fragment } from "react";
import { OrderDirection } from "~/operations";
import { DataTable } from "../data-table";
import { Pagination, PaginationProps } from "../pagination";
import { Space } from "~/lib/types";
import { useGenericTable } from "./UseGenericTable";
import { GenericTableName } from "~/components/GenericTable/GetGenericTableHeaders";

interface GenericTableProps {
  space?: Space;
  children: React.ReactNode;
  items: number;
  tableName: GenericTableName;
  validSortFields: string[];
  paginationProps?: PaginationProps;
  disableSorting?: boolean;
  allowExceptionSetting?: boolean;
  noTags?: boolean;
  printView?: boolean;
  size?: TableProps["size"];
}

export function GenericTable({
  children,
  items,
  tableName,
  validSortFields,
  ...props
}: GenericTableProps) {
  const { tableHeaders, handleSortClick, orderBy } = useGenericTable({
    tableName,
    validSortFields,
  });
  return (
    <Fragment>
      <DataTable
        selectable={props.allowExceptionSetting}
        printView={props.printView}
      >
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => {
              const { sortable } = header;
              const isSortable = sortable && !props.disableSorting;

              return (
                <TableCell
                  key={header.field}
                  align={header.options?.textAlign}
                  width={header.options?.width}
                  sx={header.options?.sx}
                >
                  {isSortable ? (
                    <TableSortLabel
                      onClick={() => handleSortClick(header.field)}
                      direction={
                        orderBy.direction === OrderDirection.Asc
                          ? "asc"
                          : "desc"
                      }
                      active={header.field === orderBy.field}
                    >
                      {header.label}
                    </TableSortLabel>
                  ) : (
                    header.label
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </DataTable>
      {props.paginationProps?.pageInfo && (
        <Pagination {...props.paginationProps} />
      )}
    </Fragment>
  );
}
